module.exports = __webpack_public_path__ + "static/media/incident_triangle_purple.e93b1e56.svg";